import { useEffect, useState } from "react";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Modal } from "../../theme/Component/Modal";
import { toast } from "react-toastify";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { SelectorDocumentFactory } from "./SelectorDocumentFactory";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import useModal, { MODAL_XL } from "../../theme/Component/hooks/useModal";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";


interface Props {
    onChange: Function;
    mNemonic?: string;
    label?: string;
}

export const DocumentStorageEditor = ({ onChange, mNemonic, label }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_DocumentFactory);

    const [valor, setValor] = useState<string>();
    const [response, setResponse] = useState<any>({
        Year: _single.getCurrenYear()
    })
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (mNemonic)
            setResponse({ ...response, Mnemonic: mNemonic ?? "" })
    }, [mNemonic])

    const getItem = () => {
        if (bean.IDDocument) {
            setModal({ ...modal, "view": false })
            setValor(`${bean.IDDocument} - ${bean.Mnemonic} - ${bean.Consecutive}`);
            onChange(bean)
        } else {
            toast.error("Documento no valido")
        }
    }

    const buscarDocumento = () => {
        instance.getDocuments(response.Year, mNemonic ? mNemonic : response.Mnemonic, response.Consecutive, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => toast.error(err));
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: false },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Estado', property: 'DocumentStateName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-eye-line', visible: true, evento: () => { getPdfAccountantDocument() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const modalDoc = useModal("Documento", MODAL_XL);

    const [documentos, setDocuementos] = useState<any>([]);

    const getPdfAccountantDocument = () => {
        instance.getPdfAccountantDocument(bean.IDDocument, bean.Mnemonic, bean.Since, _single.getAccountID()).then(
            (resp: any) => {
                modalDoc.open();
                setDocuementos(resp.DocumentURL);
            }
        ).catch(err => toast.error(err));
    }

    return (
        <>
            <label>{label ?? "Documento Seleccionado"}</label>
            <div className="form-control d-flex justify-content-between align-items-center text-wrap"
                style={{ minHeight: '35px', cursor: 'pointer' }}
                onClick={() => setModal({ ...modal, "view": true, "name": "Busqueda de Documento" })}>

                {valor ? (
                    <>
                        <span>{valor}</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-danger ms-2"
                            style={{ border: "none" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setValor(undefined);
                                setBean({});
                                onChange({});
                            }}
                        >
                            <i className="ri-close-line"></i>
                        </button>
                    </>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>


            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    <div className="col-md-6">
                        <YearSelector value={response.Year} onChange={(e) => { setResponse({ ...response, "Year": e }) }} />
                    </div>
                    {mNemonic ? (
                        <div className="col-md-6">
                            <label>Tipo de Documento</label>
                            <input disabled type="text" value={mNemonic} className="form-control" />
                        </div>
                    ) : (
                        <div className="col-md-6">
                            <SelectorDocumentFactory label="Tipo de Documento" onChange={(e) => { setResponse({ ...response, "Mnemonic": e.Mnemonic }) }} />
                        </div>
                    )}
                    <div className="col-md-6">
                        <label>Consecutivo</label>
                        <input type="number" name="consecutivo" className="form-control" value={response.Consecutive} onChange={(e) => { setResponse({ ...response, "Consecutive": parseInt(e.target.value) }) }} />
                    </div>
                    <div className="col-md-6 mt-4">
                        <BasicButton icon="ri-search-line" eventClick={buscarDocumento}>Buscar</BasicButton>
                    </div>

                    <div className="col-md-12">

                        <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                        <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal}>
                            <div className="row">
                                <div className="col">
                                    <DocumentViewer list={documentos} IDDocument={bean.IDDocument} Since={bean.Since} />
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </Modal>
        </>
    )
}